/**
 * Styles given input elements as premium locked feature.
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
var premiumInput = function(element, options) {

    var _defaults = {
        textFieldSelector: 'input[type=text], input[type=url], input[type=password]',
        imageFieldSelector: 'input[type=file]',
        switchFieldSelector: 'input[type=checkbox].switch-input',
        linkClass: 'premium-input-link',
        linkHref: 'https://www.angelcam.com/pricing',
        linkText: gettext_noop('Premium subscription feature'),
        linkIcon: 'fa fa-lock',
        inputWrapper: '<div class="premium-input"></div>',
        linkAttributes: []
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});

    // style all types of supported fields
    if (element) {
        widget.styleTextField(element.filter(widget.options.textFieldSelector));
        widget.styleImageField(element.filter(widget.options.imageFieldSelector));
        widget.styleSwitchField(element.filter(widget.options.switchFieldSelector));
    }

};

/**
 * Styles text fields.
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
premiumInput.prototype.styleTextField = function(element) {
    var widget = this;

    element.each(function() {
        var inputWrapper = $(widget.options.inputWrapper);
        $(this).wrap(inputWrapper);
        $(this).parent().append(widget._generateLink());
    });

};

/**
 * Styles file fields.
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
premiumInput.prototype.styleImageField = function(element) {
    var widget = this;

    element.each(function() {
        var inputWrapper = $(widget.options.inputWrapper);
        inputWrapper.append(widget._generateLink());
        inputWrapper.insertAfter($('.imagefield-helptext', $(this).parent()));
    });

};


/**
 * Styles switch fields.
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
premiumInput.prototype.styleSwitchField = function(element) {
    var widget = this;
    element.each(function() {
        var inputWrapper = $(widget.options.inputWrapper);
        $(this).parent().wrap(inputWrapper);
        var extraClass = ''
        if(!$(this).attr('checked')){
            extraClass='disabled'
        }
        $(this).parent().append(widget._generateLink(true, extraClass));
    });
};

/**
 * Generates link markup and return jQuery object.
 * @param {jQUery Object} element
 * @param {Object} options
 *
 */
premiumInput.prototype._generateLink = function(excludeText=false, extraClass='') {
    var widget = this;
    var icon = $('<i></i>');
    var link = $('<a></a>');
    var linkText = $('<span></span>');

    icon.addClass(widget.options.linkIcon);
    linkText.text(gettext(widget.options.linkText));
    link.addClass(widget.options.linkClass)
        .attr('href', widget.options.linkHref)
        .attr('title', widget.options.linkText)
        .append(icon);
    if (!excludeText){
        link.append(linkText);
    }
    link.addClass(extraClass);
    widget.options.linkAttributes.forEach(function(item){
        link.attr(item.attr, item.value);
    });

    return link;
};

module.exports = premiumInput;



// WEBPACK FOOTER //
// ./src/resources/js/premiumInput.js